import { DisplayInputValue, DisplayTextSignatureValue } from '@reapitform/dashboard-ui'
import { IUserProfileData } from '../../../../../api/user-profile'
import React, { FC, useMemo } from 'react'

const PersonalInformationDisplayView: FC<IUserProfileData> = ({ firstName, lastName, mobile, email }) => {
  const fullName: string = useMemo(() => {
    if (!lastName) return firstName
    return `${firstName} ${lastName}`
  }, [firstName, lastName])

  return (
    <>
      <DisplayInputValue title="Reply-to name">{fullName}</DisplayInputValue>
      <DisplayInputValue title="Reply-to email address">{email}</DisplayInputValue>
      <DisplayInputValue title="Mobile">{mobile}</DisplayInputValue>
      <DisplayInputValue title="Digital Signature">
        <DisplayTextSignatureValue value={fullName} />
      </DisplayInputValue>
    </>
  )
}

export default PersonalInformationDisplayView
